export default "__VITE_PUBLIC_ASSET__c3abfcfe__"